/** Copy and switches for the Evie widget. Keep user-facing wording here so it is easy to tune. */

export const ASKAI_TITLE = 'Evie';
export const ASKAI_SUBTITLE = 'Ask me about your cases.';

/** The Tickets tab has no data source any more; keep the UI but hide it. */
export const SHOW_TICKETS_TAB = false;

/**
 * How soon support replies after a hand-off. Shown once in the first-open banner and in every hand-off
 * line, so the dentist knows the answer comes by email (not in this chat) and roughly when.
 */
export const SUPPORT_REPLY_WINDOW = '1 business day';

export const SHOW_INTRO_BANNER = true;
export const INTRO_BANNER_SECTIONS = [
  { id: 'meet', text: `I can tell you where your cases are. Anything I can't answer goes to support, who email you within ${SUPPORT_REPLY_WINDOW}.` },
];

/** Rotating bubbles next to the launcher for a while after login. */
export const LAUNCHER_PROMPTS = [
  'Wondering where a case is? Ask me.',
  'Need an update on a case?',
  'Ask me how your case is doing.',
  'Evie is here to help.',
  'Type a case number to check it.',
];

export const MAX_CASE_PICKS = 5;

/** Small pause before a canned reply so the typing indicator is visible. */
export const BOT_REPLY_DELAY_MS = 350;

/** How long Evie's goodbye stays on screen before the end-of-chat feedback form replaces it. */
export const END_CHAT_FEEDBACK_DELAY_MS = 1500;

/** Shown when a triage request could not be delivered. */
export const SUPPORT_CONTACT_LINE = 'You can also reach our team at **support@evidentdigital.com**.';

/**
 * Evident support helpline, offered in every emergency reply. `display` is shown in full; `tel` is the
 * dialable form behind the link, so a tap on mobile starts the call.
 */
export const SUPPORT_HELPLINE = { display: '1-877-909-7770', tel: '+18779097770' };
